export default __webpack_public_path__ + "static/media/transfacil_galery_9.0a6a543a.jpg";